import React, { useEffect, useState } from 'react';
import { ArrowRight, Menu, X } from 'lucide-react';
import { nav } from '../data';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'backdrop-blur-md bg-[#0A0D17]/85 border-b border-[var(--border)]' : ''}`}>
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 h-[78px] flex items-center justify-between">
        <button
          onClick={() => { window.scrollTo(0, 0); window.dispatchEvent(new Event('empax:replayIntro')); }}
          className="flex items-center group bg-transparent border-0 p-0"
          aria-label="Replay Empax intro"
        >
          <img src="/empax-logo.png" alt="Empax Studio" className="h-14 md:h-[68px] w-auto" />
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {nav.map((item, i) => (
            <React.Fragment key={item.label}>
              <a href={item.href} className="nav-link label  hover:text-[var(--text)] transition-colors">{item.label}</a>
              {i < nav.length - 1 && <span className="text-[10px]" style={{ color: 'var(--accent-blue)' }}>·</span>}
            </React.Fragment>
          ))}
        </nav>

        <a href="#start-conversation" data-testid="nav-cta-start-conversation" className="hidden md:flex items-center gap-3 group">
          <span className="label !text-[var(--accent)] group-hover:brightness-110 transition-colors">Start a conversation</span>
          <span className="circle-btn w-9 h-9 rounded-full border border-[var(--accent)] flex items-center justify-center group-hover:bg-[var(--accent)] transition-colors duration-300">
            <ArrowRight size={15} className="arrow text-[var(--accent)] group-hover:text-[#0A0D17] transition-colors" />
          </span>
        </a>

        <button className="md:hidden text-[var(--text)]" onClick={() => setOpen(!open)} aria-label="Menu">{open ? <X size={22} /> : <Menu size={22} />}</button>
      </div>

      {open && (
        <div className="md:hidden bg-[#0A0D17]/97 backdrop-blur-md border-t border-[var(--border)] px-6 py-8 flex flex-col gap-6">
          {nav.map((item) => (
            <a key={item.label} href={item.href} className="label " onClick={() => setOpen(false)}>{item.label}</a>
          ))}
          <a href="#start-conversation" className="label  text-[var(--accent)]" onClick={() => setOpen(false)}>Start a conversation</a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
